var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoftsim = function SvgSoftsim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M2.143 6.286A3.285 3.285 0 0 1 5.429 3a1 1 0 0 1 0 2c-.71 0-1.286.575-1.286 1.286v4.571a1 1 0 0 1-.293.707L3.414 12l.436.436a1 1 0 0 1 .293.707v4.571c0 .71.575 1.286 1.286 1.286a1 1 0 1 1 0 2 3.285 3.285 0 0 1-3.286-3.286v-4.157l-.85-.85a1 1 0 0 1 0-1.414l.85-.85zM17.571 4a1 1 0 0 1 1-1 3.285 3.285 0 0 1 3.286 3.286v4.157l.85.85a1 1 0 0 1 0 1.414l-.85.85v4.157A3.286 3.286 0 0 1 18.57 21a1 1 0 1 1 0-2c.71 0 1.286-.576 1.286-1.286v-4.571a1 1 0 0 1 .293-.707l.436-.436-.436-.436a1 1 0 0 1-.293-.707V6.286c0-.71-.575-1.286-1.286-1.286a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    d: "M6.5 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7.5a1 1 0 0 1-1-1m9 0a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1"
  })));
};
export default SvgSoftsim;